module.exports = __webpack_public_path__ + "02ffaa1991cc5d4f0c9695f6006a8282.jpg";